import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { sendAnalyticResetContactUsClick } from 'services/Analytics';

import base from 'appConfig/base';

import { ContactUsLinkPropsType } from './types';

import * as S from './styled';

const ContactUsLink = ({ subject, mb, text = 'basics.contactUs' }: ContactUsLinkPropsType) => {
    const { t } = useTranslation();

    return (
        <S.ContactUsLink
            data-locator="contactUsLinkBtn"
            href={`mailto:${base.supportEmail}?subject=${t(subject)}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={sendAnalyticResetContactUsClick}
            mb={mb}
        >
            <Text dataLocator="contactButton" center color="text-main" type="medium-button">
                {t(text)}
            </Text>
        </S.ContactUsLink>
    );
};

export default ContactUsLink;
